import cn from 'classnames';

import style from '../Input/Input.module.scss';

export const COUNTRIES = [
  { code: 'PL', dial: '+48', flag: 'linear-gradient(#fff 50%,#DC143C 50%)' },
  { code: 'DE', dial: '+49', flag: 'linear-gradient(#000 33.3%,#DD0000 33.3% 66.6%,#FFCE00 66.6%)' },
  {
    code: 'CZ',
    dial: '+420',
    flag: 'linear-gradient(to right bottom,#11457E 50%,transparent 50%) 0 0/50% 50% no-repeat,linear-gradient(to right top,#11457E 50%,transparent 50%) 0 100%/50% 50% no-repeat,linear-gradient(#fff 50%,#D7141A 50%)'
  },
  { code: 'SK', dial: '+421', flag: 'linear-gradient(#fff 33.3%,#0B4EA2 33.3% 66.6%,#EE1C25 66.6%)' },
  { code: 'UA', dial: '+380', flag: 'linear-gradient(#0057B7 50%,#FFD700 50%)' },
  { code: 'LT', dial: '+370', flag: 'linear-gradient(#FDB913 33.3%,#006A44 33.3% 66.6%,#C1272D 66.6%)' }
];

export default function PhoneInput({ id, label, required, error, country, onCountryChange, countryLabel, ...rest }) {
  const { flag } = COUNTRIES.find((c) => c.code === country);

  return (
    <div className={cn(style.fld, error && style.bad)}>
      <label htmlFor={id}>
        {label}
        {required && (
          <>
            {' '}
            <i>*</i>
          </>
        )}
      </label>
      <div className={style.phoneIn}>
        <span className={style.cc}>
          <span
            className={style.flag}
            style={{ '--flag': flag }}
          />
          <select
            value={country}
            onChange={(e) => onCountryChange(e.target.value)}
            aria-label={countryLabel}
          >
            {COUNTRIES.map((c) => (
              <option
                key={c.code}
                value={c.code}
              >
                {c.dial}
              </option>
            ))}
          </select>
        </span>
        <input
          id={id}
          type='tel'
          inputMode='tel'
          autoComplete='tel-national'
          placeholder='500 600 700'
          required={required}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${id}-error` : undefined}
          {...rest}
        />
      </div>
      {error && (
        <p
          className={style.err}
          id={`${id}-error`}
        >
          {error}
        </p>
      )}
    </div>
  );
}
